
function TestToken(url, token){

    return new Promise((resolve, reject) => {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({token:token}),
        };


        fetch(url, requestOptions)
            .then((res) => res.json())
            .then((data) => {
                resolve(data);
            })
            .catch(err => {
                console.log(err.message);
                reject();
            });
    });

}


export default TestToken;